import { Box } from "../../../components/elements"
import {
  Fieldset,
  Input,
  Question,
  validations,
} from "../../../components/form"

import { useFormContext } from "react-hook-form"
import { IQuestionValues } from "../types"

const FIELDS: {
  label: string
  name: keyof IQuestionValues
  placeholder: string
  unit: string
}[] = [
  {
    label: "従業員数は何人ですか?",
    name: "num_employees",
    placeholder: "例) 500",
    unit: "人",
  },
  {
    label: "ご利用中のSaaSはいくつありますか??",
    name: "num_apps",
    placeholder: "例) 10",
    unit: "個",
  },
  {
    label: "月あたりの入社者は平均何人ですか??",
    name: "num_joins",
    placeholder: "例) 100",
    unit: "人",
  },
  {
    label: "月あたりの退職者は平均何人ですか??",
    name: "num_leaves",
    placeholder: "例) 10",
    unit: "人",
  },
]

const QuestionFields = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IQuestionValues>()

  return (
    <Box gapInRem={3} flexDirection={`column`} fullwidth>
      {FIELDS.map(({ label, name, placeholder, unit }, i) => (
        <Fieldset key={name}>
          <Question number={i + 1} text={label} />
          <Input
            error={errors[name]}
            min={0}
            placeholder={placeholder}
            registration={register(name, validations.requiredNonNegativeNumber)}
            short
            type="number"
            unit={unit}
          />
        </Fieldset>
      ))}
    </Box>
  )
}

export { QuestionFields }
